import { gql, type TypedDocumentNode } from "@apollo/client";
import type { PaginationVariables } from "@/components/Pagination/Pagination";
import type { GrpEnrollmentNode, GrpEnrollmentStatus } from "./types";

export interface GrpEnrollmentMetrics {
  activeCount: number;
  unenrolledCount: number;
}

export interface GrpEnrollmentsQueryResponse {
  grpEnrollments: {
    nodes: GrpEnrollmentNode[];
    totalCount: number;
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string;
      endCursor?: string;
    };
  };
  grpEnrollmentMetrics: GrpEnrollmentMetrics;
}

export interface GrpEnrollmentsQueryVariables extends PaginationVariables {
  filters?: {
    search?: string;
    status?: GrpEnrollmentStatus;
    facilityName?: string;
    classifications?: string[];
    states?: string[];
  };
}

export const GRP_ENROLLMENTS_QUERY: TypedDocumentNode<GrpEnrollmentsQueryResponse, GrpEnrollmentsQueryVariables> = gql`
  query GrpEnrollments(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filters: BackofficeGrpEnrollmentsInput
  ) {
    grpEnrollments(first: $first, after: $after, last: $last, before: $before, filters: $filters) {
      nodes {
        id
        memberNumber
        accountOpenedOn
        status
        classification
        state
        facilityName
        person {
          id
          firstName
          lastName
          displayName
          profilePhoto
          pgaId
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
    grpEnrollmentMetrics {
      activeCount
      unenrolledCount
    }
  }
`;
